import floor from "lodash/floor";
import min from "lodash/min";

const NAME_MAP = {
  M: "max",
  H: "heavy",
  N: "medium",
  L: "light",
  D: "deload",
};

const CHART = {
  1: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  2: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  3: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  4: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  6: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  7: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  8: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  9: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  10: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  11: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  12: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  13: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  14: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  15: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  16: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  17: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  18: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  19: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  20: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  21: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  22: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  23: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  24: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  25: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  26: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  27: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  28: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  29: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  30: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  31: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  32: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  33: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  34: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  35: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  36: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  37: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  38: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  39: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  40: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  41: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  42: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  43: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  44: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  45: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  46: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  47: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  48: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  49: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  50: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  51: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  52: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  53: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  54: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  55: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  56: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  57: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  58: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  59: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  60: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  61: [
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  62: [
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  63: [
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  64: [
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  65: [
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  66: [
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  67: [
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  68: [
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  69: [
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  70: [
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  71: [
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  72: [
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  73: [
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  74: [
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  75: [
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  76: [
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  77: [
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  78: [
    "L",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  79: [
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  80: [
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  81: [
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  82: [
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  83: [
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  84: [
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  85: [
    "N",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  86: [
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  87: [
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  88: [
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  89: [
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  90: [
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  91: [
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  92: [
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  93: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  94: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  95: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  96: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  97: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  98: [
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  99: [
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  100: [
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  99.5: [
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  98.5: [
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  97.5: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  96.5: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  95.5: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  94.5: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  93.5: [
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  92.5: [
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  91.5: [
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  90.5: [
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  89.5: [
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  88.5: [
    "N",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  87.5: [
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  86.5: [
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  85.5: [
    "N",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  84.5: [
    "N",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  83.5: [
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  82.5: [
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  81.5: [
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  80.5: [
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  79.5: [
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  78.5: [
    "L",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  77.5: [
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  76.5: [
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  75.5: [
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  74.5: [
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  73.5: [
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  72.5: [
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  71.5: [
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  70.5: [
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  69.5: [
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  68.5: [
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  67.5: [
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  66.5: [
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  65.5: [
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  64.5: [
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
  ],
  63.5: [
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  62.5: [
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  61.5: [
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  60.5: [
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  59.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  58.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  57.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
    "H",
  ],
  56.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  55.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  54.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  53.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  52.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  51.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  50.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
    "N",
  ],
  49.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  48.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  47.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  46.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  45.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  44.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  43.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  42.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  41.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
    "L",
  ],
  40.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  39.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  38.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  37.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  36.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  35.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  34.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  33.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  32.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  31.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  30.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  29.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  28.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  27.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  26.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  25.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  24.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  23.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  22.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  21.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  20.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  19.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  18.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  17.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  16.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  15.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  14.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  13.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  12.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  11.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  10.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  9.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  8.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  7.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  6.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  5.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  4.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  3.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  2.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  1.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
  0.5: [
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
  ],
};

export { getZone, CHART, NAME_MAP };
export { fromIntensity as default };

function getZone(it, defaultRepMax) {
  const repMax = it.equipped ? it.equippedRepMax : defaultRepMax;
  if (it.load > repMax) return NAME_MAP.M;
  if (it.load <= 0) return NAME_MAP.D;
  return fromIntensity(it.load / repMax, it.reps);
}

function fromIntensity(intensity, reps) {
  if (!intensity || isNaN(intensity)) return "deload";
  const percent = floor(intensity * 2) / 2;
  const bracket = CHART[percent];
  if (percent < 1) return "deload";
  if (percent > 100) return "max";
  return NAME_MAP[bracket[min([reps, bracket.length]) - 1]];
}
